import { db } from './index';
import { providers } from './schema';

export async function listProviders() {
  try {
    const items = await db.query.providers.findMany({
      orderBy: (providers, { asc }) => [asc(providers.name)],
    });
    return { success: true, data: items };
  } catch (error) {
    console.error('Error listing providers:', error);
    return { success: false, error: 'Failed to list providers' };
  }
}

export async function createProvider(name: string) {
  try {
    const [newItem] = await db.insert(providers).values({ name }).returning();
    return { success: true, data: newItem };
  } catch (error) {
    console.error('Error creating provider:', error);
    if ((error as any).code === '23505') {
      return { success: false, error: 'Ese proveedor ya existe' };
    }
    return { success: false, error: 'Error al crear el proveedor' };
  }
}

